import AppRoutes from "./Routes/AppRoutes";

function App() {
  return (
    <div className="flex flex-col p-4 pt-0 antialiased min-h-dvh bg-black font-poppins text-[clamp(1rem,0.964rem+0.179vw,1.125rem)]">
      <AppRoutes />
    </div>
  );
}

export default App;
